'use client'

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
// import TestimonialsData from '@/assets/data/testimonials.json'
import LineStroke from '../individual-components/line-stroke';
import NextImage from '../NextImage';

const Testimonials = ({ context }) => {

    const [hydrated, setHydrated] = React.useState(false);
    React.useEffect(() => {
        setHydrated(true);
    }, []);

    if (!hydrated) {
        // Returns null on first render, so the client and server match
        return null;
    }

    return (
        <div className="relative max-w-7xl px-6 sm:px-3 z-10 mx-auto text-left bg-white">
            <h2 className="text-4xl sm:text-2xl sm:m-5 font-bold text-gray-900 text-center md:text-center md:mx-auto mx-0">
                {context?.header}
            </h2>

            <div className="relative top-[-4rem] sm:-top-32 w-56 xs:w-1/2 mx-auto">
                <LineStroke />
            </div>

            <div className="relative mx-8">
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    autoplay={{
                        delay: 3000, // Set autoplay delay in milliseconds
                        disableOnInteraction: false, // Continue autoplay after user interaction
                    }}
                    slidesPerView={1}
                    breakpoints={{
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 80
                        }
                    }}
                    navigation={{
                        nextEl: '.next',
                        prevEl: '.prev',
                    }}
                    loop
                >
                    {(context?.reviews || [])?.map((testimonial, index) => (
                        <SwiperSlide key={testimonial?.author} className='mr-4 xs:mr-1 py-10 sm:py-0 sm:pb-8 px-5 xs:px-2'>
                            <div className="w-full h-full min-h-[275px] sm:min-h-[400px] py-[10%] px-[6%] rounded-xl border shadow group hover:shadow-xl">
                                <p className="text-[1rem] text-left w-full md:text-center text-secondary">
                                    "{testimonial?.quote}"
                                </p>
                                <br />
                                <p className="text-lg w-full text-black md:text-center text-left font-semibold">
                                    - {testimonial?.author}
                                </p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* <div className="xs:hidden mt-4 ml-4 block">
                    <button aria-label='prev' className="prev absolute left-[-30px] top-[50%]">
                        <NextImage
                            className="w-6 h-6 mr-5"
                            src="/images/back-button.webp"
                            alt="Previous"
                            loading="lazy"
                        />
                    </button>
                    <button aria-label='next' className="next absolute right-[-30px] top-[50%]">
                        <NextImage
                            className="w-6 h-6"
                            src="/images/next-button.webp"
                            alt="Next"
                            loading="lazy"
                        />
                    </button>
                </div> */}
            </div>
        </div >
    );
};

export default Testimonials;

